
import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import type { UserWithSubscription } from "./adminUserUtils";
import UserTableRow from "./UserTableRow";

interface UserTableProps {
  users: UserWithSubscription[];
  onDeactivate: (subscriptionId: string) => void;
  onActivate: (userId: string) => void;
  activating: boolean;
  deactivating: boolean;
  searchTerm: string;
}

const UserTable: React.FC<UserTableProps> = ({
  users,
  onDeactivate,
  onActivate,
  activating,
  deactivating,
  searchTerm,
}) => (
  <div className="overflow-x-auto">
    <div className="rounded-xl border border-gray-200 bg-white shadow-md overflow-hidden">
      <Table className="min-w-full">
        <TableHeader>
          <TableRow className="bg-muted">
            <TableHead className="py-4 px-6">User</TableHead>
            <TableHead className="py-4 px-6">Email</TableHead>
            <TableHead className="py-4 px-6">Subscription</TableHead>
            <TableHead className="py-4 px-6">Status</TableHead>
            <TableHead className="py-4 px-6">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {users?.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5} className="text-center py-10 text-gray-500">
                {searchTerm ? "No users found matching your search." : "No users found."}
              </TableCell>
            </TableRow>
          ) : (
            users.map((user, idx) => (
              <UserTableRow
                key={user.id}
                user={user}
                onActivate={onActivate}
                onDeactivate={onDeactivate}
                activating={activating}
                deactivating={deactivating}
                isLast={idx === users.length - 1}
                rowIndex={idx}
              />
            ))
          )}
        </TableBody>
      </Table>
    </div>
  </div>
);

export default UserTable;

